import { Injectable, NgZone, ChangeDetectorRef, ApplicationRef } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import {
  MatDialogRef,
  MatDialog,
  MatDialogConfig
} from "@angular/material";
import {
  AngularFireDatabase,
  AngularFireList
} from "@angular/fire/database";
import {
  ToastaService,
  ToastaConfig,
  ToastOptions
} from "ngx-toasta";
import "rxjs/Rx";

import { ReviewPopupComponent } from "../Global/ReviewPopup/ReviewPopup.component";
import { ConfirmationPopupComponent } from "../Global/ConfirmationPopup/ConfirmationPopup.component";

import { fbUser, fbCartItem, fbCart, fbShippingMetric, fbOrder } from "../Models/fbUser";
import { AuthService } from "./Auth.service";
import { Product } from "../Models/Product";
import { first, switchAll } from "rxjs/operators";
import { OrderResultModel } from "../Models/PaymetnModels";
import { ErrorPopupComponent } from "../Global/ErrorPopup/ErrorPopup.component";
import { ExchageRateService } from "./ExchageRate.service";
import { TranslateService } from "@ngx-translate/core";
import { Filter } from "../Models/Filter";


@Injectable()
export class EmbryoService {
  sidenavOpen: boolean = false;
  paymentSidenavOpen: boolean = false;
  isDirectionRtl: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _featuredProductsSelectedTab = 1;
  get featuredProductsSelectedTab(): any {
    return this._featuredProductsSelectedTab;
  }
  set featuredProductsSelectedTab(v: any) {
    this._featuredProductsSelectedTab = v;
    this.fetchFeaturedProducts();
  }

  private _newArrivalSelectedTab = 1;
  get newArrivalSelectedTab(): any {
    return this._newArrivalSelectedTab;
  }
  set newArrivalSelectedTab(v: any) {
    this._newArrivalSelectedTab = v;
    this.fetchNewProducts();
  }

  /**** Get currency code:- https://en.wikipedia.org/wiki/ISO_4217 *****/
  public exchangeMX: number = 1;
  public $exchangeMX: BehaviorSubject<number> = new BehaviorSubject<number>(1);

  private _currency: string = "TRY";
  public get currency(): string {
    return this._currency
  }

  public set currency(value: string) {
    this.fetchExchangeRate();
    this._currency = value;
  }
  currentLanguage$: BehaviorSubject<string> = new BehaviorSubject("tr");
  language: string = "english";
  USERKEY: string = "user";

  get currentShippingFee(): string {
    if (!this.shipping$)
      return "";
    if (this.shipping$.value == 0)
      return "Free";
    else return this.shipping$.value.toString() + " " + this.currency;
  };
  shipping$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  totalPrice$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  orderResult$: BehaviorSubject<OrderResultModel> = new BehaviorSubject<OrderResultModel>(null);


  products: AngularFireList<any>;
  productsByCategory: any;
  categoryProducts: AngularFireList<any>;
  // filters: FilterList;
  filterList$: BehaviorSubject< Filter[]> = new BehaviorSubject([]);
  product_lists: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  singleProduct: any = null;
  categoryNames: any[] = [];
  featuredProducts: Array<any> = new Array<any>();
  featuredProductsRepo: any;

  public newProductsOneList$: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  newProducts: Array<any> = new Array<any>();
  newProductsRepo: any;
  shippingMetrics: BehaviorSubject<fbShippingMetric[]> = new BehaviorSubject<fbShippingMetric[]>([]);

  localStorageCartProductsBehaviour: BehaviorSubject<fbCartItem[]> = new BehaviorSubject<fbCartItem[]>([]);

  public get getLocalStorageCartProductsBehaviour(): Observable<fbCartItem[]> {
    return this.localStorageCartProductsBehaviour.asObservable();
  }


  navbarCartCount: number = 0;
  buyUserCartProducts: any;

  check: boolean = true;

  fbUser$: BehaviorSubject<fbUser> = new BehaviorSubject<fbUser>(null);
  fbuser: fbUser = new fbUser();

  fbProfileOrders: fbOrder[] = [];
  fbProfileOrders$: BehaviorSubject<fbOrder[]> = new BehaviorSubject<fbOrder[]>([]);

  fbUserKey: BehaviorSubject<string> = new BehaviorSubject<any>(null);

  //Subscriptions
  public cartSubscription: any;
  public cartSubscriptionFb: any;
  private subscriptionList: any[] = [];

  constructor(
    private dialog: MatDialog,
    public db: AngularFireDatabase,
    private toastyService: ToastaService,
    private toastyConfig: ToastaConfig,
    public authService: AuthService,
    public ngZone: NgZone,
    public AppRef: ApplicationRef,
    private exchangeService: ExchageRateService,
    private translation: TranslateService
  ) {
    this.toastyConfig.position = "top-right";
    this.toastyConfig.theme = "material";
    localStorage.removeItem("user");
    localStorage.removeItem("byProductDetails");

    // this.filters = new FilterList();
    this.calculateLocalCartProdCounts();
    this.productsByCategory = {};
    this.cartSubscription = this.authService.user.subscribe(u => {
      console.log("embryo - this.authService.user changed");
      if (u !== null && u.uid !== null) {
        this.subscribeToFbCart(u.uid);
      }
    });

    this.featuredProductsRepo = {
      "men": [],
      "women": [],
      "accessories": []
    };
    this.newProductsRepo = {
      "men": [],
      "women": [],
      "accessories": []
    };

    this.ngZone.runOutsideAngular(async () => {
      await this.db.list("shipping_metrics").valueChanges().pipe(first()).toPromise().then(s => {
        this.shippingMetrics.next(s as fbShippingMetric[]);
        console.warn("fetch shipping metrics");
      });
    });

    this.fetchExchangeRate();
    setInterval(() => {
      this.fetchExchangeRate();
    }, 60000 * 10);

    this.currentLanguage$.next(this.translation.currentLang);
    this.currentLanguage$.subscribe((lang) => {
      this.translation.use(lang);
    });


  }
  ngOnDestroy() {
    console.log("embryo - destroy");
    this.closeCartSubscription();
    this.subscriptionList.forEach(sub => sub.unsubscribe());
  }
  public changeLanguage(lang: string) {
    this.currentLanguage$.next(lang);
  }

  public getFilterList(): BehaviorSubject<Filter[]> {
    this.db.list("filters").valueChanges().take(1).subscribe((result: Filter[]) => {
     this.filterList$.next(result);
    });
    return this.filterList$;
}

  public fetchExchangeRate() {
    this.exchangeService.GetExchangeRate().take(1).subscribe((result) => {
      switch (this.currency) {
        case "TRY":
          this.exchangeMX = 1;
          this.$exchangeMX.next(1);
          break;
        case "USD":
          this.exchangeMX = result.rates.USD;
          this.$exchangeMX.next(result.rates.USD);
          break;
        case "EUR":
          this.exchangeMX = result.rates.EUR;
          this.$exchangeMX.next(result.rates.EUR);
          break;
        default:
          break;
      }
      this.AppRef.tick();
    });
  }
  public getTotalPrice(): BehaviorSubject<number> {
    let total = 0;
    if (this.localStorageCartProductsBehaviour.value && this.localStorageCartProductsBehaviour.value.length > 0) {
      for (let product of this.localStorageCartProductsBehaviour.value) {
        total += (product.discount_price * product.quantity);
      }
      let metric = this.shippingMetrics.value;
      if (metric !== undefined && metric.length > 0) {
        let sortedMetrics = metric.filter(item => item.feeFrom <= total).sort((a, b) => { return b.feeFrom - a.feeFrom });
        this.shipping$.next(sortedMetrics[0].shippingPrice);
        this.totalPrice$.next(total + this.shipping$.value);
      }
    }

    return this.totalPrice$;
  }

  //GET PRODUCTS

  public getProducts() {
    console.log("embryo - get Products");
    this.products = this.db.list("/products");
    return this.products;
  }
  public getProductsByCategory(type: string, category: string) {
    console.log("embryo - getProductsByCategory ");
    this.db
      .list("/products/" + type, ref =>
        ref.orderByChild("category").equalTo(category)
      )
      .valueChanges()
      .subscribe(p => {
        console.log("embryo - getProductsByCategory - subscribe to category products");
        this.productsByCategory[type] = p;
      });
    return this.productsByCategory[type];
  }

  public getNewArrivals(): Observable<Array<any>> {
    if (this.newProductsOneList$.value.length == 0) {
      let tempArray: Array<any> = [];
      this.db
        .object("/product_lists/new")
        .valueChanges()
        .take(1)
        .subscribe(res1 => {
          (res1 as Array<any>)
            .forEach(element => {
              this.db
                .object("/products/" + element["category"] + "/" + element["id"])
                .valueChanges()
                .take(1)
                .subscribe(res2 => {
                  tempArray.push(res2);
                  this.newProductsOneList$.next(tempArray);
                });
            });
        });
    }
    return this.newProductsOneList$.asObservable();
  }
  public getSingleProduct(type: string, id: string) {
    console.log("embryo - getsingleProduct");
    return this.db.object("/products/" + type + "/" + id).valueChanges();
  }
  public getRelatedProducts(type: string) {
    console.log("embryo - getRelatedProducts");
    return this.db
      .list("/products/" + type, ref => ref.orderByKey().limitToFirst(5))
      .valueChanges();
  }

  public getCategoryNames() {
    console.log("embryo - getCategoryNames");
    return this.categoryNames;
  }

  public getCategoryProducts(type: string, cat: string, filter: string) {
    console.log("embryo - getCategoryProducts");
    let query: firebase.database.Query;
    this.categoryProducts = this.db.list("/products/" + type, ref => {
      if (cat != "" && cat != null) {
        query = ref.orderByChild("category_type").equalTo(cat);
      }
      else if (filter != "" && filter != null && filter === "new") {
        query = ref.orderByChild("new").equalTo(true);
      }
      else {
        query = ref.orderByChild("popular");
      }

      return query;
    });

    return this.categoryProducts;
  }

  /*
     ----------  Cart Product Function  ----------
  */

  // Adding new Product to cart in localStorage
  public addToCart(data: any, type: any = "") {
    console.log("embryo - addToCart");
    let products: any;
    products = JSON.parse(localStorage.getItem("cart_item")) || [];
    let productsLength = products.length;

    let toastOption: ToastOptions = {
      title: "Adding Product To Cart",
      msg: "Product adding to the cart",
      showClose: true,
      timeout: 600,
      theme: "material"
    };

    let found = products.some(function (el, index) {
      if (el.name == data.name) {
        if (!data.quantity) {
          data.quantity = 1;
        }
        products[index]["quantity"] = data.quantity;
        return true;
      }
    });
    if (!found) {
      products.push(data);
    }

    if (productsLength == products.length) {
      toastOption.title = "Product Already Added";
      toastOption.msg = "You have already added this product to cart list";
    }


    this.toastyService.wait(toastOption);
    setTimeout(() => {
      if (this.authService.user.value !== null && this.authService.user.value.uid != null && this.fbUserKey.getValue !== null) {
        let cart = this.ConvertToFbCart(products);
        this.db.object("/users/" + this.fbUserKey.getValue() + "/cart").update(cart).then();
      }
      else {
        console.log("embryo - addToCart")
        localStorage.setItem("cart_item", JSON.stringify(products));
      }
      this.calculateLocalCartProdCounts();
    }, 400);
  }


  private ConvertToFbCart(productList: any): fbCart {
    console.log("embryo - ConvertToFbCart");
    let tempCart: fbCart = new fbCart();
    let products: any[] = productList;
    if (products == null)
      products = [];
    products.forEach(item => {
      if (item !== null)
        tempCart.cartItems.push(new fbCartItem(item.features.toString(), item.image, item.price, item.discount_price, item.quantity, item.name, item.id, item.type, item.size));
    });
    if (tempCart.cartItems.length == 0)
      tempCart.cartItems.push(new fbCartItem("", "", 0, 0, 0, "", "", "", ""));
    return tempCart;
  }

  public getCartProducts(): Product[] {
    console.log("embryo - getCartProducts");
    let products: Product[];
    products = JSON.parse(localStorage.getItem("cart_item")) || [];
    return products;
  }
  public buyNow(data: any) {
    console.log("embryo - buyNow");
    let products: any;
    products = JSON.parse(localStorage.getItem("cart_item")) || [];

    let found = products.some(function (el, index) {
      if (el.name == data.name) {
        if (!data.quantity) {
          data.quantity = 1;
        }
        products[index]["quantity"] = data.quantity;
        return true;
      }
    });
    if (!found) {
      products.push(data);
    }
    if (this.authService.user.value && this.authService.user.value.uid != null && this.fbUserKey.getValue !== null) {
      let cart = this.ConvertToFbCart(products);
      this.db.object("/users/" + this.fbUserKey.getValue() + "/cart").update(cart).then();
    }
    else {
      console.log("embryo - buyNow");
      localStorage.setItem("cart_item", JSON.stringify(products));
    }
    this.calculateLocalCartProdCounts();
  }

  // Updating Item Quantity on Cart
  public UpdateLocalCartItem(data: any) {
    console.log("embryo - UpdateLocalCartItem");
    let products: any;
    products = JSON.parse(localStorage.getItem("cart_item")) || [];

    let found = products.some(function (el, index) {
      if (el.name == data.name) {
        products[index]["quantity"] = data.quantity;
        return true;
      }
    });

    if (this.authService.user.value !== null && this.authService.user.value.uid !== null && this.fbUserKey.getValue !== null) {
      let cart = this.ConvertToFbCart(products);
      this.db.object("/users/" + this.fbUserKey.getValue() + "/cart").update(cart).then();
    }
    else {
      console.log("embryo - UpdateLocalCartItem");
      localStorage.setItem("cart_item", JSON.stringify(products));
    }
    // this.calculateLocalCartProdCounts();
  }

  //Enter [] to clear all local cart products
  public updateAllLocalCartProduct(products: any) {
    console.warn("embryo - updateAllLocalCartProduct");
    if (this.authService.user.value && this.authService.user.value.uid != null && this.fbUserKey.getValue !== null) {
      let cart = this.ConvertToFbCart(products);
      this.db.object("/users/" + this.fbUserKey.getValue() + "/cart").update(cart).then(_ => console.warn("xxxxxxxxxx embryo DONE - updateAllLocalCartProduct"));
    }
    else {
      console.warn("embryo - updateAllLocalCartProduct");
      localStorage.removeItem("cart_item");
      localStorage.setItem("cart_item", JSON.stringify(products));
    }
  }

  public clearLocalCart() {
    localStorage.removeItem("cart_item");
    localStorage.setItem("cart_item", JSON.stringify([]));
    this.calculateLocalCartProdCounts();

  }


  // returning LocalCarts Product Count
  public calculateLocalCartProdCounts() {
    console.log("embryo - calculateLocalCartProdCounts");
    let localStorageCartProducts =
      JSON.parse(localStorage.getItem("cart_item")) || [];
    this.navbarCartCount = +localStorageCartProducts.length;
    this.localStorageCartProductsBehaviour.next(localStorageCartProducts);

  }

  // Removing cart from local
  public removeLocalCartProduct(product: any) {
    console.log("embryo - removeLocalCartProduct");
    let products: any = JSON.parse(localStorage.getItem("cart_item"));

    for (let i = 0; i < products.length; i++) {
      if (products[i].id === product.id) {
        products.splice(i, 1);
        break;
      }
    }

    let toastOption: ToastOptions = {
      title: "Remove Product From Cart",
      msg: "Product removing from cart",
      showClose: true,
      timeout: 600,
      theme: "material"
    };

    this.toastyService.wait(toastOption);
    setTimeout(() => {
      if (this.authService.user.value !== null && this.authService.user.value.uid != null && this.fbUserKey.getValue !== null) {
        let cart = this.ConvertToFbCart(products);
        this.db.object("/users/" + this.fbUserKey.getValue() + "/cart").update(cart).then();
      }
      else {
        console.log("embryo - removeLocalCartProduct");
        localStorage.setItem("cart_item", JSON.stringify(products));
      }
      this.calculateLocalCartProdCounts();
    }, 400);
  }


  public closeCartSubscription() {
    console.log("embryo - closeCartSubscription");
    this.cartSubscription.unsubscribe();
    this.cartSubscriptionFb.unsubscribe();

  }
  public subscribeToFbCart(uid: string) {
    console.log("embryo - subscribeToFbCart");
    this.cartSubscriptionFb = this.db.list("/users", ref => ref.orderByChild("uid").equalTo(uid)).valueChanges().subscribe(user => {
      if (user !== null && user !== undefined && user[0]["cart"] !== undefined) {
        console.log("embryo - subscribeToFbCart - subscribe to user");
        let items: fbCartItem[] = user[0]["cart"]["cartItems"];
        items.forEach((element, index) => {
          if (element.id == "")
            items.splice(index, 1);
        });
        localStorage.setItem("cart_item", JSON.stringify(items));
        this.calculateLocalCartProdCounts();
      }
    });

    this.cartSubscription = this.db.list("/users", ref => ref.orderByChild("uid").equalTo(uid)).snapshotChanges().take(1).subscribe(ref => {
      console.log("embryo - subscribeToFbCart - subscribe to user for uid");
      this.fbUserKey.next(ref[0].key);
    });

  }

  /**
   * Buy Product functions
   */
  public addBuyUserDetails(formdata) {
    console.log("embryo - addBuyUserDetails");
    localStorage.setItem("user", JSON.stringify(formdata));

    let product = JSON.parse(localStorage.getItem("cart_item"));
    localStorage.setItem("byProductDetails", JSON.stringify(product));
    this.buyUserCartProducts = JSON.parse(
      localStorage.getItem("byProductDetails")
    );

    localStorage.removeItem("cart_item");
    this.calculateLocalCartProdCounts();
  }

  public removeBuyProducts() {
    console.log("embryo - removeBuyProducts");
    localStorage.removeItem("byProductDetails");
    this.buyUserCartProducts = JSON.parse(
      localStorage.getItem("byProductDetails")
    );
  }




  public updateFBUser() {
    console.log("embryo - updateFBUser");
    this.db.list('/users', ref => ref.orderByChild("uid").equalTo(this.fbuser.uid))
      .snapshotChanges().take(1).subscribe(actions => {
        console.log("embryo - updateFBUser- subscribe for uid");
        this.db.object("/users/" + actions[0].key).update(this.fbuser);
      });
  }
















  public fetchFeaturedProducts(): void {
    if (this.featuredProductsRepo["women"].length == 0) {
      this.db
        .object("/product_lists/featured")
        .valueChanges()
        .take(1)
        .subscribe(res1 => {
          (res1 as Array<any>)
            .forEach(element => {
              this.db
                .object("/products/" + element["category"] + "/" + element["id"])
                .valueChanges()
                .take(1)
                .subscribe(res2 => {
                  this.featuredProductsRepo[element["category"]].push(res2);
                });
            });


        });
    }
    console.error(this.featuredProductsSelectedTab);
    switch (this.featuredProductsSelectedTab) {
      case 0:
        this.featuredProducts = this.featuredProductsRepo["women"];
        break;
      case 1:
        this.featuredProducts = this.featuredProductsRepo["men"];
        break;
      case 2:
        this.featuredProducts = this.featuredProductsRepo["accessories"];
      default:
        break;
    }
  }

  public fetchNewProducts(): void {
    if (this.newProductsRepo["men"].length == 0) {
      this.db
        .object("/product_lists/new")
        .valueChanges()
        .take(1)
        .subscribe(res1 => {
          (res1 as Array<any>)
            .forEach(element => {
              this.db
                .object("/products/" + element["category"] + "/" + element["id"])
                .valueChanges()
                .take(1)
                .subscribe(res2 => {
                  this.newProductsRepo[element["category"]].push(res2);
                });
            });

        });
    }
    switch (this.newArrivalSelectedTab) {
      case 0:
        this.newProducts = this.newProductsRepo["women"];
        break;
      case 1:
        this.newProducts = this.newProductsRepo["men"];
        break;
      case 2:
        this.newProducts = this.newProductsRepo["accessories"];
      default:
        break;
    }
  }















  //Out Of Working Scope

  public reviewPopup(singleProductDetails, reviews) {
    let review: MatDialogRef<ReviewPopupComponent>;
    const dialogConfig = new MatDialogConfig();
    if (this.isDirectionRtl.value) {
      dialogConfig.direction = "rtl";
    } else {
      dialogConfig.direction = "ltr";
    }

    review = this.dialog.open(ReviewPopupComponent, dialogConfig);
    review.componentInstance.singleProductDetails = singleProductDetails;
    review.componentInstance.reviews = reviews;

    return review.afterClosed();
  }

  public confirmationPopup(message: string) {
    let confirmationPopup: MatDialogRef<ConfirmationPopupComponent>;
    confirmationPopup = this.dialog.open(ConfirmationPopupComponent);
    confirmationPopup.componentInstance.message = message;

    return confirmationPopup.afterClosed();
  }

  public errorPopup(message: string) {
    let errorPopup: MatDialogRef<ErrorPopupComponent>;
    errorPopup = this.dialog.open(ErrorPopupComponent);
    errorPopup.componentInstance.message = message;

    return errorPopup.afterClosed();
  }


  /**
   * getTeam used to get the team data.
   */
  public getTeam() {
    let team: any;
    team = this.db.list("team");
    return team;
  }

  /**
   * getTestimonial used to get the testimonial data.
   */
  public getTestimonial() {
    let testimonial: any;
    testimonial = this.db.object("testimonial");
    return testimonial;
  }

  /**
   * getMissionVision used to get the Mission and Vision data.
   */
  public getMissionVision() {
    let mission_vision: any;
    mission_vision = this.db.list("mission_vision");
    return mission_vision;
  }

  /**
   * getAboutInfo used to get the about info data.
   */
  public getAboutInfo() {
    let about_info: any;
    about_info = this.db.object("about_info");
    return about_info;
  }

  /**
 * Profile functions
 */

  public fetchUserForProfile() {
    this.authService.user.subscribe(value => {
      if (value !== null) {
        this.db
          .list("/users", ref => ref.orderByChild("uid").equalTo(value.uid))
          .valueChanges()
          .subscribe(result => {
            if (result && result.length > 0) {
              this.fbuser = JSON.parse(JSON.stringify(result[0]));
              this.fbUser$.next(this.fbuser);
            }
          });
        this.db
          .list("/profile_orders", ref => ref.orderByChild("buyerId").equalTo(value.uid))
          .valueChanges()
          .subscribe(result => {
            if (result && result.length > 0) {
              this.fbProfileOrders = JSON.parse(JSON.stringify(result));
              this.fbProfileOrders$.next(this.fbProfileOrders);
            }
          });

      }
    });
  }


  /**
   * getBlogList used to get the blog list.
   */
  public getBlogList() {
    let blogs: any;
    blogs = this.db.list("blogs");
    return blogs;
  }

  /**
   * getContactInfo used to get the contact infomation.
   */
  public getContactInfo() {
    let contact: any;
    contact = this.db.object("contact");
    return contact;
  }

  /**
   * getTermCondition used to get the term and condition.
   */
  public getTermCondition() {
    let termCondition: any;
    termCondition = this.db.list("term_condition");
    return termCondition;
  }

  /**
   * getPrivacyPolicy used to get the privacy policy.
   */
  public getPrivacyPolicy() {
    let privacyPolicy: any;
    privacyPolicy = this.db.list("privacy_policy");
    return privacyPolicy;
  }

  /**
   * getFaq used to get the faq.
   */
  public getFaq() {
    let faq: any;
    faq = this.db.object("faq");
    return faq;
  }

  /**
   * getProductReviews used to get the product review.
   */
  public getProductReviews() {
    let review: any;
    review = this.db.list("product_reviews");
    return review;
  }



}
